import globalAxios from 'axios';

/* tslint:disable */
const BASE_PATH = "https://shop_checkout".replace(/\/+$/, "");
/**
 *
 * @export
 * @class BaseAPI
 */
class BaseAPI {
    basePath;
    axios;
    configuration;
    constructor(configuration, basePath = BASE_PATH, axios = globalAxios) {
        this.basePath = basePath;
        this.axios = axios;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
}

export { BASE_PATH, BaseAPI };
//# sourceMappingURL=base.js.map
